import { Action } from 'redux-actions';
import { all, put, takeLatest } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getLoansRequest } from '../../api/Repairer/loans/getLoansQuery';

import { GET_LOANS } from './actionTypes';

interface GetLoansPayload {
  fileId: string;
  sellerId: string;
}

function* getLoansWorker({ payload }: { payload: GetLoansPayload }): Generator {
  const { fileId, sellerId } = payload;
  const meta = { fileId, indexer: fileId };

  yield executeSagaRequest(GET_LOANS, getLoansRequest({ fileId, sellerId }), meta);

  yield put(GET_LOANS.end(meta));
}
function* getLoansWatcher() {
  yield takeLatest<Action<GetLoansPayload>>(GET_LOANS.BASE, getLoansWorker);
}

export default function* mainSaga() {
  try {
    yield all([getLoansWatcher()]);
  } catch (error: any) {
    logCritical(error);
  }
}
